import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
export function Blog() {
  const blogPosts = [{
    title: 'The Power of Voice: How Conversations Shape the Future',
    excerpt: 'In every generation, there are movements that shift the world — not through weapons or wealth, but through words. Discover how meaningful conversations create lasting change.',
    image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&h=400&fit=crop',
    slug: 'power-of-voice',
    date: 'January 2025'
  }, {
    title: 'Behind the Scenes: How Voices with Victoria Became a Platform for Changemakers',
    excerpt: 'Every great idea begins with a question. Discover the journey of how Voices with Victoria evolved from a simple idea into a movement of changemakers across Africa.',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop',
    slug: 'behind-the-scenes',
    date: 'January 2025'
  }];
  return <Layout data-id="element-127">
      <div className="max-w-7xl mx-auto px-6 py-16" data-id="element-128">
        <div className="text-center mb-12" data-id="element-129">
          <h1 className="text-5xl font-bold text-black mb-4" data-id="element-130">Blog</h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-131">
            Insights, stories, and inspiration from the Voices with Victoria
            community
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-132">
          {blogPosts.map((post, index) => <Link key={index} to={`/blog/${post.slug}`} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border-t-4 border-voices-red group" data-id="element-133">
              <img src={post.image} alt={post.title} className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-134" />
              <div className="p-6" data-id="element-135">
                <div className="text-voices-gold font-semibold text-sm mb-2" data-id="element-136">
                  {post.date}
                </div>
                <h2 className="text-2xl font-bold text-black mb-3 group-hover:text-voices-red transition-colors" data-id="element-137">
                  {post.title}
                </h2>
                <p className="text-gray-600 mb-4" data-id="element-138">{post.excerpt}</p>
                <span className="text-voices-red font-semibold group-hover:text-red-700" data-id="element-139">
                  Read More →
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </Layout>;
}